import request from '@/utils/request'
let baseUrl = '/api/competition/ranking'
export function listAll(compId,stageId){
    return request({
        url: baseUrl+'/listAll',
        method: 'get',
        params: { compId: compId,stageId: stageId}
      })
}

export function list(data){
    return request({
        url: baseUrl+'/list',
        method: 'get',
        params: data
      })
}

export function listWeek(compId,stageId){
  return request({
      url: baseUrl+'/listWeek',
      method: 'get',
      params: { compId: compId,stageId: stageId}
    })
}


// WEBPACK FOOTER //
// ./src/api/ranking.js